import { render, staticRenderFns } from "./marketDetailCopy.vue?vue&type=template&id=a0b286c8&scoped=true"
import script from "./marketDetailCopy.vue?vue&type=script&lang=js"
export * from "./marketDetailCopy.vue?vue&type=script&lang=js"
import style0 from "./marketDetailCopy.vue?vue&type=style&index=0&id=a0b286c8&prod&lang=less&scoped=true"
import style1 from "./marketDetailCopy.vue?vue&type=style&index=1&id=a0b286c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b286c8",
  null
  
)

export default component.exports